// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function PageNotFound(props) {
  return <div>
    {"Page not found"}
  </div>;
}

let make = PageNotFound;

export {
  make,
}
/* react/jsx-runtime Not a pure module */
